import React, { useState } from "react";
import styled from "styled-components";
import { IonItem, IonIcon, IonButton } from "@ionic/react";
import { pencilOutline } from "ionicons/icons";
import strings from "../../../../res/strings";

const OuterContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 50px;
  padding-right: 50px;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
`;

const DataDisplay = styled.div`
  border-radius: 20px;
  border: 1px solid rgba(146, 146, 146, 0.67);
  box-sizing: border-box;
  padding: 8px;
  width: 80%;

  :hover {
    background: #f0f5fc;
  }
`;
const DataHeader = styled.div`
  font-weight: bold;
  font-size: 0.9em;
  color: #000000;
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  margin-right: 16px;
  width: 20%;
  text-align: right;
`;
const EditIcon = styled(IonIcon)`
  font-size: 1.2em;
`;
const Data = styled(IonItem)`
  --background: transparent;

  :hover {
    --background: #f0f5fc !important;
  }
  cursor: pointer;
  color: #666666;
`;

const EditComponentContainer = styled.div`
  border-radius: 20px;
  border: 1px solid rgba(146, 146, 146, 0.67);
  box-sizing: border-box;
  padding: 8px;
  width: 80%;
`;
const SaveButtonContainer = styled.div`
  padding: 4px 16px 4px 16px;
`;
const SaveButton = styled(IonButton)`
  font-size: 0.8em;
`;
const CancelButton = styled(IonButton)`
  font-size: 0.8em;
`;

const EditableDataDisplay = (props) => {
  const [editing, setEditing] = useState(false);

  const handleCancel = (e) => {
    setEditing(false);
  };

  const handleClickData = (e) => {
    props.closeActiveFormEdit();
    props.openActiveFormEdit(handleCancel);
    setEditing(true);
  };

  const dataDisplay = (
    <DataDisplay>
      {/* <DataHeader color="white" style={props.headerStyle}>
        {props.label}
      </DataHeader> */}
      <Data lines="none" onClick={handleClickData}>
        {props.value} <EditIcon icon={pencilOutline} slot="end" />
      </Data>
    </DataDisplay>
  );

  const editComponent = (
    <EditComponentContainer>
      {props.editComponent}
      <SaveButtonContainer>
        <SaveButton type="submit" color="tertiary">
          {strings.lib_common_action_save}
        </SaveButton>
        <CancelButton color="danger" onClick={handleCancel}>
          {strings.lib_common_action_cancel}
        </CancelButton>
      </SaveButtonContainer>
    </EditComponentContainer>
  );

  return (
    <OuterContainer>
      <Container>
        <DataHeader color="white" style={props.headerStyle}>
          {props.label.toUpperCase()}
        </DataHeader>
        {editing ? editComponent : dataDisplay}
      </Container>
    </OuterContainer>
  );
};

export default EditableDataDisplay;
